import { render, staticRenderFns } from "./delete.vue?vue&type=template&id=55303a92&"
import script from "./delete.vue?vue&type=script&lang=js&"
export * from "./delete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/franciscoriquelme/Documents/Elipse.ia/Proyectos/elipse-citas/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('55303a92')) {
      api.createRecord('55303a92', component.options)
    } else {
      api.reload('55303a92', component.options)
    }
    module.hot.accept("./delete.vue?vue&type=template&id=55303a92&", function () {
      api.rerender('55303a92', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/vue/components/Configuraciones/ListaNegra/delete.vue"
export default component.exports